export const isIdeHost = typeof acquireVsCodeApi !== 'undefined' ||
    (typeof location !== 'undefined' &&
        new URLSearchParams(location.search).get('host') === 'jetbrains');
